import { render } from "./AppHeaderDropdownNotif.vue?vue&type=template&id=ef16aa2c"
import script from "./AppHeaderDropdownNotif.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownNotif.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__